import { defineComponent as _defineComponent } from 'vue'
import BasicButton from '@/ui-components/BasicButton.vue';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'NoOfferBell',
  props: {
    hasText: { type: Boolean, default: true },
    isTitleInWatchlist: { type: Boolean },
    inline: { type: Boolean },
    compact: { type: Boolean }
  },
  emits: ["onNotifyMe"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'onNotifyMe'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { hasText: boolean, isTitleInWatchlist?: boolean, inline?: boolean, compact?: boolean };





function onNotifyMe() {
	emits('onNotifyMe');

	if (props.isTitleInWatchlist) return;
	TrackingHelper.trackEvent('userinteraction', { action: 'notify_me_clicked' });
}

return { __sfc: true,props, emits, onNotifyMe, BasicButton }
}

})